import { slideDown, slideUp } from "../../components/GLOBAL";

document.addEventListener('DOMContentLoaded', function () {
  ymaps.ready(function () {
    document.querySelectorAll('.map[data-coord]').forEach(function (mapBlock) {
      const coords = mapBlock.getAttribute('data-coord').split(',').map(Number);

      const map = new ymaps.Map(mapBlock, {
        center: coords,
        zoom: 16,
        controls: ['zoomControl']
      });

      // Кастомная иконка
      const customIcon = new ymaps.Placemark(coords, {}, {
        iconLayout: 'default#image',
        iconImageHref: mapBlock.getAttribute('data-marker'), // Путь к вашей иконке
        iconImageSize: [66, 66], // Размер иконки (ширина, высота)
        iconImageOffset: [-33, -33] // Смещение (чтобы кончик указывал точно на координату)
      }); 

      map.geoObjects.add(customIcon);
      map.behaviors.disable('scrollZoom');
    });
  });
  document.querySelectorAll('.faq').forEach((item)=>{
	const head = item.querySelector('.faq__head')
	const body = item.querySelector('.faq__body')
	if(item.classList.contains('_open')){
		slideDown(body)
	}
	head.addEventListener('click',()=>{
		if(item.classList.contains('_open')){
			item.classList.remove('_open')
			slideUp(body)
		}else{
			item.classList.add('_open')
			slideDown(body)
		}
	})
  })
});